/**
 * Toast utility for consistent notifications.
 * This is just a re-export of sonner's toast with documentation to
 * encourage its use instead of direct imports from sonner.
 * 
 * Example:
 * import { toast } from '@/lib/toast';
 * 
 * // Basic usage
 * toast('Hello world');
 * 
 * // Variants
 * toast.success('Operation successful');
 * toast.error('Something went wrong');
 * toast.warning('Heads up!');
 * toast.info('Did you know?');
 * toast.loading('Please wait...');
 * 
 * // With options
 * toast('Custom options', {
 *   duration: 5000,
 *   icon: '🚀',
 * });
 */
export { toast } from 'sonner'; 